<template>
  <img class="logo" v-if="themeStore.theme.logo" :src="themeStore.theme.logo" :style="style" />
  <WowziLogo class="logo" v-else :style="style" />
</template>

<script>
  import { useThemeStore } from '@/store/theme';
  import { mapStores } from 'pinia';
  import WowziLogo from '@/assets/img/wowzi_logo.svg';

  export default {
    name: 'WLogo',
    components: { WowziLogo },

    props: {
      height: {
        type: String,
        default: '100px',
      },
      width: {
        type: String,
        default: '100px',
      },
    },

    computed: {
      ...mapStores(useThemeStore),

      style() {
        return `height : ${this.height}; width : ${this.width};`;
      },
    },
  };
</script>

<style scoped>
  .logo {
    max-width: 100%;
  }
</style>
